import React, {useState} from 'react';
import './Subcontent.css';
import Toggle from '../Toggle/Toggle';

function Content_button(props) {
const [state, setState] = useState(false);
const [color, setColor] = useState(true)
const stateChange = () => {
  setState(!state);
  setColor(!color);
}

    return (
        <>
          <div className="content_button" style={color?{backgroundColor:"var(--blue)" ,color:"var(--white)" }:{backgroundColor:"var(--white)", color:"var(--black",  boxShadow : "1px 1px 3px 3px rgb(211, 211, 211)"}  } onClick={() => stateChange()} >
          {` Unit-${props.unit}: ${props.unit_name} `}
         {state?    <div className="toggle_option">
         <Toggle topic="1.1 Welcome to the course" />
         <Toggle topic="1.2 Why vedic Maths?" />
         <Toggle topic="1.3 Fundamental-1" />
         <Toggle topic="1.4 Fundamental-2" />
         </div> :null }
      
          </div>  
        </>
    )
}

export default Content_button
